import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Arrow from '../../../images/arrow.svg';
import ArrowLine from '../../../images/arrowLine.svg';

const Directions = {
  up: 'up',
  down: 'down',
  right: 'right',
  left: 'left',
};

const StyledArrow = styled.div`
  svg {
    ${props => {
      let transform;
      switch (props.rotation) {
        case Directions.up:
          transform = 'rotate(-90deg)';
          break;
        case Directions.down:
          transform = 'rotate(90deg)';
          break;
        case Directions.left:
          transform = 'rotate(180deg)';
          break;
        case Directions.right:
        default:
          transform = 'rotate(0deg)';
      }
      return {
        transform,
      };
    }}
    path {
      ${props => {
        let strokeColor;
        let strokeWidth;
        if (!props.line) {
          strokeColor = props.color;
          strokeWidth = 3;
        }
        return {
          stroke: strokeColor,
          strokeWidth,
        };
      }}
    }
  }
`;

const ArrowIcon = ({ rotation, line, color, testid }) => (
  <StyledArrow rotation={rotation} color={color} line={line} data-testid={testid}>
    {line ? <ArrowLine data-testid="arrow-with-line" /> : <Arrow data-testid="arrow-no-line" />}
  </StyledArrow>
);

ArrowIcon.propTypes = {
  line: PropTypes.bool,
  rotation: PropTypes.string,
  color: PropTypes.string,
  testid: PropTypes.string,
};

ArrowIcon.defaultProps = {
  line: false,
  rotation: 'right',
  color: '#fff',
  testid: null,
};

export default ArrowIcon;
